import { createSlice } from "@reduxjs/toolkit";
import { defaultItemPermission, SCHEDULE_MODE } from "./utils";

const itemPermission = await defaultItemPermission();
const bukkenSearchConditions = {
  isCollapse: true,
  construct_start_dt: "",
  construct_end_dt: "",
  bukken_num: "",
  progress: [],
  construct_department_uuids: [],
  ...itemPermission,
  bukken_uuids: [],
  bukken_name: null,
  sagyo_department_uuids: [],
  employee_uuids: [],
  sagyo_customer_uuids: [],
  customer_employee_uuids: [],
  bukken_customer_uuids: [],
  own_manager_name: null,
  bukken_department_name: null,
  customer_name: null,
  sagyo_department_name: null,
  sagyo_customer_name: null,
  employee_name: null,
  bukken_customer_name: null,
  customer_employee_name: null
};

const sagyoSearchConditions = {
  isCollapse: true,
  sagyo_department_uuids: [],
  sagyo_customer_uuids: [],
  employee_uuids: [],
  customer_employee_uuids: [],
  sagyo_department_name: null,
  sagyo_customer_name: null,
  employee_name: null,
  customer_employee_name: null
};

export const stateWhiteBoardSlice = createSlice({
  name: "stateWhiteBoard",
  initialState: {
    currentMode: SCHEDULE_MODE.PROPERTY,
    [SCHEDULE_MODE.PROPERTY]: {
      ...bukkenSearchConditions
    },
    propertySearchPayload: {},
    [SCHEDULE_MODE.WORKER]: {
      ...sagyoSearchConditions
    },
    sagyoSearchPayload: {}
  },
  reducers: {
    setBukkenConditions: (state, action) => {
      state[SCHEDULE_MODE.PROPERTY] = {
        ...state[SCHEDULE_MODE.PROPERTY],
        ...action.payload
      };
    },
    triggerPropertySearch: (state) => {
      const { isCollapse, ...rest } = state[SCHEDULE_MODE.PROPERTY];
      state.propertySearchPayload = rest;
    },
    setSagyoConditions: (state, action) => {
      state[SCHEDULE_MODE.WORKER] = {
        ...state[SCHEDULE_MODE.WORKER],
        ...action.payload
      };
    },
    triggerSagyoSearch: (state) => {
      const { isCollapse, ...rest } = state[SCHEDULE_MODE.WORKER];
      state.sagyoSearchPayload = rest;
    },
    changeBoardMode: (state, action) => {
      state.currentMode = action.payload;
    },
    resetBukkenConditions: (state, action) => {
      state[SCHEDULE_MODE.PROPERTY] = {
        ...bukkenSearchConditions,
        construct_manager_uuids: [],
        bukken_customer_employee_uuids: [],
        isCollapse: false,
        ...action.payload
      };
    },
    resetSagyoConditions: (state, action) => {
      state[SCHEDULE_MODE.WORKER] = { ...sagyoSearchConditions, isCollapse: false, ...action.payload };
    },
    clearStateWhiteBoard: (state) => {
      state.currentMode = SCHEDULE_MODE.PROPERTY;
      state[SCHEDULE_MODE.PROPERTY] = {};
      state.propertySearchPayload = {};
      state[SCHEDULE_MODE.WORKER] = { ...sagyoSearchConditions };
      state.sagyoSearchPayload = {};
    }
  }
});

export const loadStateWhiteBoard = () => {
  try {
    const serializedState = localStorage.getItem("stateWhiteBoard");
    if (serializedState === null) return undefined;

    return {
      stateWhiteBoard: JSON.parse(serializedState)
    };
  } catch (e) {
    console.error("Could not load state", e);
    return undefined;
  }
};

export const localStorageMiddleware = (store) => (next) => (action) => {
  const result = next(action);
  const state = store.getState();
  localStorage.setItem("stateWhiteBoard", JSON.stringify(state.stateWhiteBoard));
  return result;
};

export const {
  setBukkenConditions,
  triggerPropertySearch,
  setSagyoConditions,
  triggerSagyoSearch,
  resetBukkenConditions,
  resetSagyoConditions,
  changeBoardMode,
  clearStateWhiteBoard
} = stateWhiteBoardSlice.actions;

export default stateWhiteBoardSlice.reducer;
